import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { messages } from './purchase-order-status.messages';
import styles from './purchase-order-status.styles.module.less';
import { purchaseOrderStatuses } from '../../data/purchase-order-statuses';

/**
 * Purchase Order Status component
 * Displays the status of a purchase order with appropriate styling
 * Different statuses (Draft, Open, Received, Cancelled, Closed) are displayed
 * with different colors and visual indicators
 * @param {object} props - Component props
 * @param {string} props.status - The status to display
 * @returns {JSX.Element} The status component
 */
export const PurchaseOrderStatus = ({ status }) => {
  if (!status) {
    return null;
  }

  return (
    <div className={classnames(styles['status-container'], styles[`status-container-${status.toLowerCase()}`])}>
      {status !== purchaseOrderStatuses.closed && (
        <span className={classnames(styles['status-dot'], styles[`status-dot-${status.toLowerCase()}`])} />
      )}
      <span>
        <FormattedMessage {...messages[status.toLowerCase()]} />
      </span>
    </div>
  );
};
